import React, { useEffect } from 'react';
import { MindMapContext } from '../../Context/contex';
import {
    listenEdgeAdd,
    listenEdgeAddOff,
    listenEdgeDelete,
    listenEdgeDeleteOff,
    listenNodeAdd, listenNodeAddOff,
    listenNodeDelete, listenNodeDeleteOff,
    listenNodeUpdate, listenNodeUpdateOff, listenUpdateMultiple, listenAllocateColor
} from '../../Socket/socket';
import { isRespectiveDocument } from '../../Utils/helper';
import { applyRemoteAllocatedColor, applyRemoteNodeUpdate } from './applyRemoteNodeUpdate';

const SocketListener = () => {
    const { setNodes, edges, setEdges } = MindMapContext();
    useEffect(() => {

        listenNodeAdd((data) => {
            const { documentId } = data;
            if (!documentId) {
                return;
            }
            const canChange = isRespectiveDocument(documentId);
            if (canChange) {
                setNodes((prevNodes) => [data, ...prevNodes]);
            }
        });

        //If Neccessary, will be uncommented

        // listenUpdateMultiple((data)=>{
        //     console.log('data From Listener',data)
        //     setNodes((data) =>
        //     data.map((node) => {
        //       return node;
        //     })
        //   );
        // })

        listenAllocateColor((data) => {
            const { documentId } = data;
            if (!documentId) {
                return;
            }
            const canChange = isRespectiveDocument(documentId);
            if (canChange) {
                if (data.nodeBg) {
                    setNodes((nds) => nds.map((node) => applyRemoteAllocatedColor(node, data)));
                }
            }
        })

        listenEdgeAdd((data) => {
            const { documentId } = data;
            if (!documentId) {
                return;
            }
            const canChange = isRespectiveDocument(documentId);
            if (canChange) {
                setEdges((edge) => [data, ...edge,]);
            }
        });
        listenNodeDelete((data) => {
            const { selectedNodeId, documentId } = data;
            if (!selectedNodeId || !documentId) {
                return;
            }
            const canChange = isRespectiveDocument(documentId);
            if (canChange) {
                setNodes((nds) => nds.filter((node) => node.id !== selectedNodeId));
            }
        });
        listenNodeUpdate((data) => {
            const { documentId } = data;
            if (!documentId) {
                return;
            }
            const canChange = isRespectiveDocument(documentId);
            if (canChange) {
                setNodes((nds) => nds.map((node) => applyRemoteNodeUpdate(node, data)));
            }
        });

        listenEdgeDelete(data => {
            const { selectedEdgeId, documentId } = data;
            if (!selectedEdgeId || !documentId) {
                return;
            }
            const canChange = isRespectiveDocument(documentId);
            if (canChange) {
                const updatedEdges = edges.filter(edge => edge.id !== selectedEdgeId);
                setEdges(updatedEdges);
            }
        });

        return () => {
            listenNodeAddOff();
            listenNodeUpdateOff();
            listenEdgeAddOff();
            listenEdgeDeleteOff();
            listenNodeDeleteOff();
        };
    }, [edges]); // Added edges to the dependency array to ensure it updates properly

    return <div></div>;
};

export default SocketListener;
// 